import { put } from 'redux-saga/effects';
import { replace } from 'connected-react-router';

export function* navigateToRoute({ route }) {
  yield put(replace(route));
}
